<script>
    import { fade } from 'svelte/transition';
    import {link , push} from 'svelte-spa-router'
    import { fetchDataBot }  from '../../api.js';
    import UserStore from '../../stores/user';
    import { _ } from "svelte-i18n";
    import { onMount } from 'svelte';
    import Header from '../../components/Header.svelte';
    import TopInfo from '../../components/TopInfo.svelte';  
    import Preloader from '../../components/Preloader.svelte'; 

    export let params;

    let base_id = params.base_id;
    let isLoading = false;
    let data = [];
    
    onMount(async() => {

        if (!$UserStore || !$UserStore.data){
            push('/login');
            return;
        }       
        
        fetchPage();
        
    })

    async function fetchPage() {

        isLoading = true;
        let postData = {};
        postData.action = 'tables';
        postData.base_id = base_id
        postData.token = $UserStore.data;

        let response = await fetchDataBot(postData);
        if (response.data) {

            data = [...response.data]

        }

        isLoading = false;

    }


    
</script>

<div class="page-container" transition:fade={{ delay: 250, duration: 300 }}>
    <Preloader {isLoading}/>
    <Header />
    <div class="page">

        <TopInfo />   
        
        <div class="dash-list">        
            <div class="orders-top">
                <div class="orders-top-up">
                    <h1 class="text-[20px] font-bold">{$_('bot.table.title')}</h1>
                    <span on:click={()=> { } } class="create_button"><span>{$_('bot.table.add')}</span></span>
                </div>
                <div class="locations_desc">{$_('bot.table.desc')}</div>
                <div class="table table-shipments">
                    <div class="head">
                        <div>{$_('bot.table.id')}</div>
                        <div>{$_('bot.table.name')}</div>
                        <div></div>
                    </div>
                    {#each data as item,index}
                    <div class="content">
                        <div class="input_con">
                            {item.id}
                        </div>
                        <div class="input_con">
                            {item.name}
                        </div>
                        <div>
                            <div class="button small_button" on:click={()=> { push (`/bot/bases/${base_id}/tables/${item.id}`)} }>{$_('bot.table.open')}</div>
                        </div>
                    </div>
                    {/each}
                </div>
            </div>
        </div>
    </div>
</div>
